(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      window.addEventListener('scroll', this.onScroll.bind(this));
      this.addEventListener('preventHeaderReveal', () => this.preventReveal = true);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll.bind(this));
    }

    createObserver() {
      new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
      }).observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch?.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) requestAnimationFrame(() => this.reveal());
        else requestAnimationFrame(() => this.hide());
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.querySelectorAll('header-menu').forEach(d => d.close?.());
      this.querySelector('details-modal')?.close?.(false);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ────────────────────────────────────────────────────────────────
  // Coins click → open widget → auto Sign Up if not logged in
  // ────────────────────────────────────────────────────────────────
  // document.addEventListener('DOMContentLoaded', () => {
  //   const trigger = document.getElementById('coins-icon-trigger');

  //   if (!trigger) {
  //     console.warn('[Coins] Trigger element not found');
  //     return;
  //   }

  //   trigger.addEventListener('click', () => {
  //     console.log('[Coins] Clicked');

  //     // Open Retenzy widget using the existing #widget-btn
  //     const widgetBtn = document.getElementById('widget-btn');
  //     if (widgetBtn) {
  //       widgetBtn.click();
  //       console.log('[Retenzy] Widget opened');
  //     } else {
  //       console.warn('[Retenzy] #widget-btn not found');
  //     }

  //     // If not logged in → auto-click Sign Up button after delay
  //     if (!window.Shopify?.customer?.id) {
  //       setTimeout(() => {
  //         const signupBtn = document.querySelector('.rtz-card-body-btn');
  //         if (signupBtn && signupBtn.offsetParent !== null) {
  //           console.log('[Retenzy] Auto-clicking Sign Up');
  //           signupBtn.click();
  //         } else {
  //           console.log('[Retenzy] Sign Up button not found yet');
  //         }
  //       }, 1400);  // ← adjust delay if needed (1200–2500 ms)
  //     }
  //   });
  // });

  } catch(e) { console.error(e); }
})();
})();
